var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "brick-settings-base",
        {
          attrs: {
            title: _vm.resource("JourneyComposer_BrickSettingsJourney_Title"),
            canWrite: _vm.canWrite,
            prompt: {
              title: _vm.resource(
                "JourneyBuilder_JourneySettings_Delete_Title"
              ),
              body: _vm.resource("JourneyBuilder_JourneySettings_Delete_Body")
            }
          },
          on: {
            save: _vm.saveSettings,
            delete: function($event) {
              return _vm.$emit("delete")
            },
            hidden: function($event) {
              return _vm.$emit("hide")
            }
          },
          model: {
            value: _vm.newName,
            callback: function($$v) {
              _vm.newName = $$v
            },
            expression: "newName"
          }
        },
        [
          _c("settings-item", {
            attrs: { icon: "fas fa-route" },
            scopedSlots: _vm._u(
              [
                {
                  key: "label",
                  fn: function() {
                    return [
                      _c("label", { attrs: { for: _vm.fieldName } }, [
                        _vm._v(_vm._s(_vm.fieldName))
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c("v-select", {
                        staticClass: "form-control",
                        attrs: {
                          id: _vm.fieldName,
                          options: _vm.journeys,
                          disabled: !_vm.canWrite || _vm.journeys.length === 0,
                          clearable: false,
                          searchable: "",
                          filterable: ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function() {
                                return undefined
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          2167505365
                        ),
                        model: {
                          value: _vm.selectedJourney,
                          callback: function($$v) {
                            _vm.selectedJourney = $$v
                          },
                          expression: "selectedJourney"
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2356182298
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }